module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAQlBMVEUAAABixn1ixn1ixn1ixn1ixn1ixn1ixn1ixn1ixn1ixn1ixn1ixn1ixn1ixn1ixn1ixn1ixn1ixn1ixn1ixn1ixn0RUMYnAAAAFXRSTlMA9T96p5f46i8S+lcX676uhUUuDAcsypu2AAAAdUlEQVQoz8XSuxKDMAxE0VWiADaEt///V5mh2B0wpoRtz9xKQvAqXa7yAE/FDVCXt0g3exTHpS3iF0BNzG1imdvHiNZbZsQZzf9kxLgCTX00lT/sKiNKZUIpjSjtaEQpTUiVCaVda68dW2h3r+lldASP1xQ9bBqfNyyywBgmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/wx_xz_green.png
// module id = 7GQS
// module chunks = 0